import { Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IndicadorInfo } from '../../dashboard.model';
import { catchErr } from 'src/app/shared/utils';
import { DashboardGeralService } from '../..';

@Component({
    selector: 'app-dashboard-geral',
    templateUrl: './dashboard-geral.component.html',
    styleUrls: ['./dashboard-geral.component.css'],
    standalone: false
})
export class DashboardGeralComponent implements OnInit {
    @Input() dashboardData: any | null = null; // mantido por compatibilidade, não utilizado
    indicadoresGerais: IndicadorInfo[] = [];

    constructor(private geralService: DashboardGeralService, private snackBar: MatSnackBar) {}

    ngOnInit(): void {
        this.geralService.getIndicadoresGerais().subscribe({
            next: (res) => {
                this.indicadoresGerais = this.geralService.buildIndicadoresGerais(res);
            },
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    getCorClasse(cor: string): string {
        const cores: { [key: string]: string } = {
            'primary': 'text-primary',
            'success': 'text-success',
            'warn': 'text-danger',
            'accent': 'text-warning'
        };
        return cores[cor] || 'text-primary';
    }
}
